import { Injectable } from "@angular/core";
import { Observable, catchError, map, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment'; 
import { URL_MAP } from "../../shared/urlMap";

@Injectable({
  providedIn: 'root'
})
export class CodigoAsesorService {

  // private readonly apiUrl = `${environment.API.CODIGOASESOR}`;
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.CODIGOASESOR}`;

  constructor(
    private httpClient: HttpClient,
  ) {}

  public getCodigoAsesor(documento: string): Observable<number> {
    const body = {
      nombreClave: "getSpAsesorDocumento",
      jsonParametros: JSON.stringify({ prm_docu_asesor: documento })
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        'Content-Type': 'application/json'
      })
    };

    return this.httpClient.post<any>(this.apiUrl, body, httpOptions).pipe(
      map(response => {
        if (response?.status && response?.data?.length > 0) {
          return response.data[0].idasesor;
        } else {
          throw new Error('No se encontró idasesor en la respuesta');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener el código del asesor:', error);
        return throwError(() => error);
      })
    );
  }

  public obtenerDataAsesor(documento: string): Observable<any> {
    const body = {
      nombreClave: "getSpAsesorDocumento",
      jsonParametros: JSON.stringify({ prm_docu_asesor: documento })
    };

    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': '*/*',
        'Content-Type': 'application/json'
      })
    };

    return this.httpClient.post<any>(this.apiUrl, body, httpOptions).pipe(
      map(response => {
        if (response?.status && response?.data?.length > 0) {
          return response.data[0];
        } else {
          throw new Error('No se encontró información del asesor en la respuesta');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener la información del asesor:', error);
        return throwError(() => error);
      })
    );
  }
}